<form [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (submit)="saveOrUpdate()" RestrictFocus *ngIf="fields && formReady">
  <div class="ui-grid ui-grid-responsive ui-fluid" >

    <input formControlName="id" type="hidden" pInputText/>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.service_type_id.nullable}">{{ fields.service_type_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown [options]="serviceTypes" formControlName="service_type_id" [style]="{'width':'100%'}" placeholder="Select a Service Type"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.service_type_id"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.name.nullable}">{{ fields.name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="name" pInputText [maxlength]="fields.name.width" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.name"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="description" pInputText [maxlength]="fields.description.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.description"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.flg_direct_active.nullable}">{{ 'serviceList.directActive' | translate }}</label></div>
      <div class="ui-grid-col-8">
        <!--<input type="text" formControlName="flg_direct_active" pInputText [maxlength]="fields.flg_direct_active.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.flg_direct_active"></app-validation-msg>-->
        <p-dropdown [options]="flgDirectActiveList" formControlName="flg_direct_active" [style]="{'width':'100%'}" placeholder="Select a Service Type"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.flg_direct_active"></app-validation-msg>
      </div>
    </div>

  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{ dataEdit && dataEdit.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'serviceList.service' | translate }}"></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/service/serviceForm.html